import React from 'react';

const StatCard = ({ icon, title, subtitle, value, percentageChange, changeType }) => {
    return (
        <div className="card h-100">
            <div className="card-body">
                <div className="card-header d-flex justify-content-between">
                    <div className="card-title mb-0">
                        <h5 className="mb-1">{title}</h5>
                    </div>
                </div>
                <div className={`badge p-2 bg-label-${changeType} mb-3 rounded`}>
                    <i className={`ti ${icon} ti-28px`}></i>
                </div>
                <p className="card-subtitle">{subtitle}</p>
                <p className="text-heading mb-3 mt-1">{value}</p>
                <div>
                    <span className={`badge bg-label-${changeType}`}>
                        {percentageChange}%
                    </span>
                </div>
            </div>
        </div>
    );
};

export default StatCard;
